import { useState } from "react";
import { Link } from "react-router-dom";
import { Bot, Lock, Target, CalendarDays, Trophy, BarChart3, Ticket } from "lucide-react";
import useBranding from "@/hooks/useBranding";
import CompetitionPicker from "@/components/CompetitionPicker";
import Fixtures from "@/components/Fixtures";
import Standings from "@/components/Standings";
import PredictionFeed from "@/components/public/PredictionFeed";
import Hero from "@/components/public/Hero";
import PublicStats from "@/components/public/PublicStats";
import Schedina from "@/components/public/Schedina";

const TABS = [["feed", "Pronostici", Target], ["schedina", "Schedina", Ticket], ["calendar", "Calendario", CalendarDays], ["standings", "Classifiche", Trophy], ["stats", "Statistiche", BarChart3]];
const DEFAULT_COMP = { code: "SA", name: "Serie A", type: "LEAGUE", area: "Italy" };

export default function PublicSite() {
  const { name, username } = useBranding();
  const [tab, setTab] = useState("feed");
  const [comp, setComp] = useState(DEFAULT_COMP);
  const tg = username ? `https://t.me/${username}` : "#";

  return (
    <>
      <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
          <div data-testid="public-logo" className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 shrink-0 rounded-lg bg-[var(--gold)] text-slate-950 grid place-items-center"><Bot size={22} strokeWidth={2.5} /></div>
            <div className="font-display text-xl sm:text-2xl font-extrabold uppercase leading-none truncate">{name || "…"}</div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a data-testid="public-telegram-btn" href={tg} target="_blank" rel="noreferrer" className="btn btn-tg"><Bot size={16} /><span className="hidden sm:inline">Apri su Telegram</span></a>
            <Link data-testid="public-admin-link" to="/admin" className="btn btn-ghost" title="Area riservata"><Lock size={16} /><span className="hidden md:inline">Admin</span></Link>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 py-8 space-y-10">
        <Hero name={name} tg={tg} onExplore={() => { setTab("feed"); document.getElementById("public-content")?.scrollIntoView({ behavior: "smooth" }); }} />

        <nav id="public-content" className="scroll-mt-24 flex gap-1 border-b border-slate-800 overflow-x-auto">
          {TABS.map(([id, label, Icon]) => (
            <button key={id} data-testid={`public-tab-${id}`} onClick={() => setTab(id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap transition-colors duration-200 ${tab === id ? "border-[var(--gold)] text-white" : "border-transparent text-slate-400 hover:text-white"}`}>
              <Icon size={16} /> {label}
            </button>
          ))}
        </nav>

        {tab === "feed" && <PredictionFeed />}
        {tab === "stats" && <PublicStats />}
        {tab === "schedina" && <Schedina tg={tg} />}
        {(tab === "calendar" || tab === "standings") && <CompetitionPicker value={comp} onChange={setComp} />}
        {tab === "calendar" && <Fixtures competition={comp} readOnly />}
        {tab === "standings" && <Standings competition={comp} />}

        <p className="pt-8 text-xs text-slate-500 font-mono">Pronostici AI solo a scopo informativo. Gioca responsabilmente (18+).</p>
      </main>
    </>
  );
}
